import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';

import { LocalizationPipe } from '@abp/ng.core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { LoadingPanelService } from '../../services';

@Component({
  selector: 'nexweb-loading-panel',
  templateUrl: './loading-panel.component.html',
  imports: [LocalizationPipe, AsyncPipe, MatProgressSpinner],
})
export class LoadingPanelComponent implements OnInit, OnDestroy {
  public modal!: boolean;

  private service = inject(LoadingPanelService);
  private router = inject(Router);
  private _showModalSubscription$!: Subscription;
  private _hideModalSubscription$!: Subscription;

  constructor() {
    this._hideModalSubscription$ = this.router.events.subscribe(() => {
      this.service.modal(false);
    });
  }

  ngOnInit() {
    //modal
    this._showModalSubscription$ = this.service
      .getModal$()
      .pipe(
        map((modal: boolean) => {
          this.modal = modal;
        }),
      )
      .subscribe();
  }

  public getLoading$() {
    return this.service.getLoading$();
  }

  public getModal$() {
    return this.service.getModal$;
  }

  public loadingMessage$(): Observable<string> {
    return this.service.loadingMessage$();
  }

  ngOnDestroy(): void {
    if (this._showModalSubscription$) {
      this._showModalSubscription$.unsubscribe();
    }

    if (this._hideModalSubscription$) {
      this._hideModalSubscription$.unsubscribe();
    }
  }
}
